<template>
  <div>
    <order-back
      :visible.sync="visible.orderBack"
      :callback="callback"
      :components="components"
      :message="message"
      :messages="messages"
      :default-prolong-time="defaultProlongTime"
      :title="title===null?'订单退回':title"/>
    <order-confirm
      :visible.sync="visible.orderConfirm"
      :callback="callback"
      :components="components"
      :title="title===null?'订单审核通过':title"
      :marketPhotos="marketPhotos"
      :salary="salary"
      :orderDetail="orderDetail"
    />
    <question-not-passed
      :visible.sync="visible.questionNotPassed"
      :callback="callback"
      :messages="messages"
      :components="components"
      :title="title===null?'题目审核不通过':title"/>
  </div>
</template>

<script>
import OrderBack from './OrderBack'
import OrderConfirm from './OrderConfirm'
import QuestionNotPassed from './QuestionNotPassed'

export default {
  name: 'ReviewBox',
  mixins: [],
  components: {QuestionNotPassed, OrderConfirm, OrderBack},
  data () {
    return {
      visible: {
        orderBack: false,
        orderConfirm: false,
        questionNotPassed: false,
      },
      message: '',
      messages: [],
      components: {},
      callback: Function.prototype,
      salary: 0,
      marketPhotos: [],
      title: null,
      orderDetail: {},
      defaultProlongTime: null,
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss"
       scoped>
</style>



// WEBPACK FOOTER //
// src/views/question-review/components/ReviewBox/src/main.vue